
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-scheduler/event-timeline/resources",
      function () {
        return require("private-next-pages/x/react-scheduler/event-timeline/resources.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-scheduler/event-timeline/resources"])
      });
    }
  